@reference "@glow/tailwind-config/reference.css";

.notification-card {
  @apply p-4;
  @apply flex;
  @apply flex-col;
  @apply w-96;
  @apply mt-4;
  animation: slide-in 1s;
}

@keyframes slide-in {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
